import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainChangeCard(params) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/changeCard`,
    method: "post",
    params: params,
  });
}
